import React from "react";
import {useDispatch} from "react-redux";

import WsPush from "../../store/wsPush";
import AllowNotifications from "../../components/AllowNotifications/AllowNotifications";
import PendingOrders from "../Orders/PendingOrders";
import List from "./List";
import {onOrderLoadDetails, onOrdersRemovePending} from "../../store/Orders/actions";
import UpdatesOrders from "../Orders/UpdatesOrders";
import SoundNotifications from "../../components/SoundNotifications/SoundNotifications";
import { useGetSettings } from '../../network';

const StaffOrders = () => {
    const dispatch = useDispatch()

    // load settings for all pages
    useGetSettings()

    const onOrderClick = (orderId) => {
        dispatch(onOrdersRemovePending(0))
        dispatch(onOrderLoadDetails(orderId))
    }

    return (
        <>
            <WsPush />

            <AllowNotifications />
            <SoundNotifications />
            <UpdatesOrders />
            <PendingOrders onOrderClick={onOrderClick} />
            <List onOrderClick={onOrderClick} />
        </>
    )
}

export default StaffOrders
